import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router';
import {
  getListNavigationState,
  type ListNavigationState,
} from './useListBackHref';

type DetailViewType =
  | 'expense'
  | 'deposit'
  | 'listing'
  | 'owner'
  | 'connection';

type GoToDetailOptions = {
  subPath?: string;
  replace?: boolean;
  state?: ListNavigationState | null;
};

const DETAIL_BASE_PATHS: Record<DetailViewType, string> = {
  expense: '/expense',
  deposit: '/deposit',
  listing: '/listing',
  owner: '/owner',
  connection: '/connection',
};

const buildDetailPath = (
  type: DetailViewType,
  id: string,
  subPath?: string
) => {
  const base = `${DETAIL_BASE_PATHS[type]}/${id}`;
  if (!subPath) return base;

  return `${base}/${subPath.replace(/^\/+/, '')}`;
};

export const useGoToDetailView = (type: DetailViewType) => {
  const goto = useNavigate();
  const location = useLocation();
  const getCurrentLocation = () =>
    typeof window === 'undefined'
      ? location
      : {
          pathname: window.location.pathname,
          search: window.location.search,
        };

  return useCallback(
    (id: string, options?: GoToDetailOptions) => {
      const path = buildDetailPath(type, id, options?.subPath);
      const state =
        options?.state ?? getListNavigationState(getCurrentLocation());

      goto(path, {
        replace: options?.replace,
        state: state ?? undefined,
      });
    },
    [goto, location, type]
  );
};
